// extracted by mini-css-extract-plugin
export default {"root":"CategoryBreadcrumbs-root","title":"CategoryBreadcrumbs-title","wide":"CategoryBreadcrumbs-wide","small":"CategoryBreadcrumbs-small"};